import { render, staticRenderFns } from "./editSigningPreferential.vue?vue&type=template&id=bb58a9fa&scoped=true&"
import script from "./editSigningPreferential.vue?vue&type=script&lang=js&"
export * from "./editSigningPreferential.vue?vue&type=script&lang=js&"
import style0 from "./editSigningPreferential.vue?vue&type=style&index=0&id=bb58a9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58a9fa",
  null
  
)

export default component.exports